<template>
  <!-- 连词成句 -->
  <div class="common-panel">
    <div class="panel-content" v-if="jsonData.answers">
      <!-- <question-description :jsonData="jsonData" :code="jsonData.topic_type"></question-description> -->
      <div class="panel-content-stem">{{ serial ? serial + ". " : "" }}{{ descriptionText }}</div>
      <div class="example" v-if="!isSPC">
        {{ jsonData.is_example ? $t("hsk_example") : jsonData.index }}
      </div>
      <!-- 填空选项 -->
      <div class="panel-content-input">
        <div v-for="(item, index) in inputAnswers" :key="index" @click="clickItem(index, item)">
          <div class="input-item" v-if="item.text">
            {{ item.text }}
          </div>
        </div>

        <div class="input-line"></div>
      </div>
      <!-- 答案选项 -->
      <div class="panel-content-answer">
        <ul class="answer-list" ref="answers">
          <li
            v-for="(option, index) in jsonData.answers"
            :key="`${jsonData.index}${index}`"
            class="answer-item"
            :ref="`refAnswer${option.id}`"
            @click="checkHandler($event, option)"
          >
            {{ option.content }}
          </li>
        </ul>
      </div>
      <!-- 结果提示 -->
      <div class="panel-content-result result-correct" v-if="isShowAnAnalysis && isCorrect && !jsonData.is_example">
        <p class="correct-tips">
          {{ $t("textbook_chioce_word_text_correct_tip") }}
        </p>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer" v-html="analysisText"></p>
        </div>
      </div>

      <div class="panel-content-result result-error" v-if="isShowAnAnalysis && !isCorrect && !jsonData.is_example">
        <p class="error-tips">
          {{ $t("textbook_chioce_word_text_error_tip") }}
        </p>
        <div class="result-show">
          <div class="correct-answer">
            {{ $t("hsk_correct_answer") }}
            <div style="padding-right: 15px; margin-top: 10px" v-for="(answer, aIndex) in correctAnswers" :key="aIndex">
              <span v-for="(item, index) in answer" :key="index">
                {{ jsonData.answers.length > 1 ? index + 1 + "、" : "" }}{{ item }}
              </span>
            </div>
          </div>
        </div>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer" v-html="analysisText"></p>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import { mixinCommon } from "@/mixins";
export default {
  mixins: [mixinCommon],
  data() {
    return {
      // 试题数组
      items: [],
      // 当前小题Index
      currIndex: 0,
      blankType: "",
      // 当前小题填空项
      inputAnswers: [],
      // 是否已经提交
      isSubmit: false,
      // 禁止点击
      isDisabled: false,
      // 当前小题是否作答成功
      isCorrect: null,
      changeBtn: false,
      correctArray: [],
    };
  },
  computed: {
    isFinished() {
      return !this.inputAnswers.some((item) => item.text === "");
    },
    // 正确答案
    correctAnswers() {
      let rightAnswerList = this.jsonData.correct_answer.map((item) => {
        return item.answer.split(",");
      });
      return rightAnswerList.map((item) => {
        return item.map((a) => {
          return this.jsonData.answers.find((b) => b.id == a).content;
        });
      });
    },

    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    analysisText() {
      return this.jsonData.analysis[this.language]
        ? this.jsonData.analysis[this.language].replace(/\……/g, "······")
        : this.jsonData.analysis["cn"].replace(/\……/g, "······");
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj["zh"]
        : "";
    },
  },
  watch: {
    jsonData: {
      handler(val) {
        if (val && val.correct_answer) {
          this.setInputAnswers();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 设置填空选项
    setInputAnswers() {
      this.correctArray = this.jsonData.correct_answer.map((item) => {
        return this.splitCorrectAnswers(item.answer.split(","));
      });
      if (this.jsonData.is_example) {
        let correctAnswer = this.jsonData.correct_answer[0].answer.split(",");
        this.inputAnswers = correctAnswer.map((item, index) => {
          return {
            text: this.searchText(item),
            answerIndex: index,
          };
        });
      } else if (this.jsonData.answer) {
        let myAnswerArray = this.jsonData.answer.split(",").filter((item) => item);
        if (myAnswerArray.length == this.jsonData.answers.length) {
          this.inputAnswers = myAnswerArray.map((item, index) => {
            return {
              text: this.searchText(item),
              answerIndex: index,
            };
          });
        } else {
          this.inputAnswers = myAnswerArray.map((item, index) => {
            return {
              text: this.searchText(item),
              answerIndex: index,
            };
          });
          this.jsonData.answers.map((item, index) => {
            if (index >= myAnswerArray.length) {
              this.inputAnswers.push({
                text: "",
                answerIndex: index,
              });
            }
          });
        }

        this.$nextTick(() => {
          myAnswerArray.map((item) => {
            this.$refs[`refAnswer${item}`][0].classList.add("active");
          });
        });
        //查看结果情况下判断是否回答正确
        if (this.isShowAnAnalysis) {
          let correctAnswers = this.jsonData.correct_answer.map((item) => {
            return item.answer;
          });
          let myAnswerArray = this.jsonData.answer.split(",").filter((item) => item);
          this.isCorrect = correctAnswers.includes(myAnswerArray.join());
        }
      } else {
        this.inputAnswers = this.jsonData.answers.map((item, index) => {
          return {
            text: "",
            answerIndex: index,
          };
        });
      }
    },
    //点击上方input区块
    clickItem(inputIndex, item) {
      if (this.jsonData.is_example) {
        return;
      }
      if (this.isShowAnAnalysis) {
        return;
      }
      if (item.text) {
        let removeId = this.jsonData.answers.find((chooseItem) => item.text === chooseItem.content).id;
        this.removeInput({
          inputIndex: inputIndex,
          removeId: removeId,
        });
      }
    },
    // 点击答题
    checkHandler(event, option) {
      if (this.jsonData.is_example) {
        return;
      }
      if (this.isShowAnAnalysis) {
        return;
      }
      const target = event.currentTarget;
      if (target.classList.contains("active")) {
        // 已选择则取消
        target.classList.remove("active");
        const chooseIndex = this.inputAnswers.findIndex((item) => item.text === option.content);
        this.cancelInput(chooseIndex);
      } else {
        // 未选择
        const emptyInputIndex = this.inputAnswers.findIndex((item) => item.text === "");
        if (emptyInputIndex == -1) return;

        target.classList.add("active");

        this.inputAnswers.splice(emptyInputIndex, 1, {
          answerIndex: emptyInputIndex,
          text: option.content,
        });
      }
      this.handleSubmit();
    },
    // 点击填空，取消答案
    removeInput({ inputIndex, removeId }) {
      if (this.jsonData.is_example) {
        return;
      }
      if (this.isShowAnAnalysis) {
        return;
      }
      this.$refs[`refAnswer${removeId}`][0].classList.remove("active");
      this.cancelInput(inputIndex);
      this.handleSubmit();
    },

    // 提交
    handleSubmit() {
      if (this.jsonData.is_example) {
        return;
      }
      // 判断答案是否正确
      let correctAnswers = this.jsonData.correct_answer.map((item) => {
        return item.answer;
      });
      let array = this.inputAnswers.filter(function (item) {
        return item.text;
      });
      let anserArray = array.map((item) => {
        return this.searchIndex(item.text);
      });
      let anserArraySubmit = this.inputAnswers.map((item) => {
        return this.searchIndex(item.text);
      });
      let userAnswer = anserArray.join();
      let userAnswerSubmit = anserArraySubmit.join();
      this.isCorrect = correctAnswers.includes(userAnswer);
      let NumArray = this.correctArray.map((item) => {
        return this.checkNodeNum(item, userAnswer);
      });
      console.log(NumArray);
      //多个答案情况下，取节点匹配最多的数量
      let max = NumArray.reduce((a, b) => {
        return b > a ? b : a;
      });
      console.log(max);
      let myScore = (max / (this.jsonData.answers.length - 1)) * this.jsonData.score;
      // 作答的对象
      let ansObj = {
        questionId: this.jsonData.index,
        answer: userAnswerSubmit,
        judge: this.isCorrect ? 1 : 0,
        scores: myScore,
        segmentCode: this.jsonData.segment_code,
        partCode: this.jsonData.part_code,
        ifGroup: this.jsonData.ifGroup,
      };
      console.log("ansObj1====", ansObj);
      this.$emit("customInterface", this.isFinished ? ansObj : "");
      //选中后延时1s再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      });
    },
    //判断某个id的text
    searchText(id) {
      let content = "";
      for (let i = 0; i < this.jsonData.answers.length; i++) {
        if (this.jsonData.answers[i].id == id) {
          content = this.jsonData.answers[i].content;
        }
      }
      return content;
    },
    //根据某个text判断下标，提交答案时使用
    searchIndex(text) {
      if (!text) {
        return "";
      }
      let indexObj = this.jsonData.answers.find((item) => item.content === text);
      return indexObj.id;
    },
    //取消input数组中某个，重新进行排序
    cancelInput(inputIndex) {
      this.inputAnswers.splice(inputIndex, 1, {
        answerIndex: this.jsonData.answers.length,
        text: "",
      });
      this.inputAnswers.forEach((element, index) => {
        if (index > inputIndex) {
          element = {
            answerIndex: element.answerIndex > 1 ? element.answerIndex - 1 : element.answerIndex,
            text: element.text,
          };
          this.$set(this.inputAnswers, index, element);
        }
      });
      this.inputAnswers.sort(this.compare("answerIndex"));
    },
    // 数组数值排序
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },

    splitCorrectAnswers(array) {
      let length = this.jsonData.answers.length;
      let answerArray = [];
      this.jsonData.answers.map((item, index) => {
        if (index < length - 1) {
          answerArray.push("");
        }
      });
      answerArray = answerArray.map((element, index) => {
        return array[index] + "," + array[index + 1];
      });
      return answerArray;
    },
    //查看最终答案包含几个答案分组节点
    checkNodeNum(nodeArray, answerStr) {
      let num = 0;
      nodeArray.forEach((item) => {
        if (answerStr.indexOf(item) > -1) {
          num++;
        }
      });
      return num;
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-content {
  width: 100%;
  padding: 90px 29px 0px 29px;
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
    min-width: 20px;
    display: flex;
    justify-content: center;
  }
  &-answer {
    margin: 80px 0 40px 0;

    .answer-list {
      width: 626px;
      margin: 0 auto;
      background: #fafafb;
      border-radius: 4px;
      padding: 20px 16px;

      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .answer-item {
        cursor: pointer;
        height: 30px;
        margin: 10px;
        padding: 0px 15px;
        border: 1px solid #515571;
        border-radius: 4px;
        background: #ffffff;
        color: #2c2f46;
        font-size: 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &:hover {
          opacity: 0.6;
        }
        &.active {
          opacity: 0.2;

          // ::v-deepp.pinyin > span {
          //   color: #838996 !important;
          // }
          // ::v-deepp.hz > span {
          //   color: #838996 !important;
          // }
        }
      }
    }
  }
  &-result {
    padding: 40px 30px 20px 0;
    border-top: 1px dashed #e6eaef;
    width: 100%;
    &.result-error,
    &.result-correct {
      p.error-tips {
        font-size: 14px;
        color: #fc5a5a;
        margin-bottom: 20px;
      }
      p.correct-tips {
        font-size: 14px;
        color: rgba(9, 203, 160, 1);
        margin-bottom: 20px;
      }
      .result-show {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
      }
      .your-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
        img {
          width: 12px;
          height: 12px;
          margin-left: 20px;
        }
      }
      p.correct-answer {
        font-size: 14px;
        font-weight: 500;
        color: rgba(84, 89, 97, 1);
        line-height: 14px;
      }
      .correct-box {
        background: rgba(251, 252, 255, 1);
        border: 1px solid rgba(242, 243, 247, 1);
        border-radius: 10px;
        padding: 20px;

        &-title {
          font-size: 14px;
          font-weight: bold;
          color: rgba(63, 70, 81, 1);
          margin-bottom: 10px;
        }
        &-answer {
          font-size: 14px;
          font-weight: 400;
          color: rgba(84, 89, 97, 1);
          line-height: 21px;
          white-space: pre-line;
        }
      }
    }
  }
  &-input {
    width: 626px;
    min-height: 50px;
    display: flex;
    flex-wrap: wrap;
    margin: 20px auto;
    position: relative;
    .input-item {
      cursor: pointer;
      height: 30px;
      margin: 0px 10px 20px 0px;
      padding: 0px 15px;
      border: 1px solid #515571;
      border-radius: 4px;
      color: #3f4651;
      font-size: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .input-line {
      width: 626px;
      height: 1px;
      background-color: #3f4651;
      margin: 0 auto;
      position: absolute;
      bottom: 0px;
      left: 0px;
    }
  }
  &-stem {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
  }
}
</style>
